<template>
	<b-modal ref="modal" hide-footer>
		<template v-slot:modal-title>
			{{ $t('monte.congelation.modifier_quantite_lot') }}
		</template>

		<div class="row" v-if="lot">
			<div class="col-12 form-group">
				<label for="semencelot_qte">{{ $t('monte.congelation.nb_paillettes') }} *</label>
				<input class="form-control" type="number" :min="qte_used" id="semencelot_qte" v-model="semencelot_qte">
				<small v-if="qte_used > 0" class="form-text text-muted">{{ $t('monte.congelation.nb_paillettes_com') }} : {{ qte_used }}</small>
			</div>
			<div class="col-12 text-center">
				<b-button variant="primary" @click="checkForm">
					<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse class="mr-1"/>
					<font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1"/>{{ $t('global.enregistrer') }}
				</b-button>
			</div>
		</div>
	</b-modal>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'ModalEditLotQte',
		mixins: [Congelation],
		data () {
			return {
				lot: null,
				semencelot_qte: 0,
				processing: false
			}
		},

		methods: {
			openModal(lot) {
				this.lot = lot
				this.semencelot_qte = lot.semencelot_qte
				this.processing = false
				this.$refs.modal.show()
			},

			async checkForm() {
				if(this.processing) {
					return false
				}

				const qte = parseInt(this.semencelot_qte)
				if(isNaN(qte) || qte < 0) {
					this.failureToast('formulaire.erreur_champs_non_remplis')
					return false
				}

				if(qte < this.qte_used) {
					this.failureToast('monte.congelation.erreur_quantite_inferieure_consommee')
					return false
				}

				const params = {
					semencelot_date: this.lot.semencelot_date,
					semencelot_quantieme: this.lot.semencelot_quantieme,
					semencelot_volume: this.lot.semencelot_volume,
					semencelot_couleur: this.lot.semencelot_couleur,
					semencelot_dilueur: this.lot.dilueur ? this.lot.dilueur.semencedilueur_id : (this.lot.semencelot_dilueur || null),
					semencelot_observation: this.lot.semencelot_observation,
					semencelot_comportement: this.lot.semencelot_comportement,
					semencelot_commentaire: this.lot.semencelot_commentaire,
					semencelot_qte: qte
				}

				this.processing = true
				const result = await this.editLot(this.lot.semencelot_id, params)
				this.processing = false

				if(!result) {
					this.failureToast('toast.info_save_failed')
					return false
				}

				this.successToast('toast.info_save_succes')
				this.$refs.modal.hide()
				this.$emit('submit')
			}
		},

		computed: {
			qte_used() {
				return this.lot && this.lot.qte_used ? this.lot.qte_used : 0
			}
		}
	}
</script>
